// Breeze + wind charge (M22.1 trial chambers). PURE (ENG-1). A breeze fires wind
// charges that burst on impact: the burst pushes entities away (knockback falling
// off to the edge) and toggles "activatable" blocks (levers/buttons/doors/…) it
// catches. Keeping the burst curve + the activatable set here makes them unit tests.
import { BREEZE } from '../config';

/** Knockback impulse a wind-charge burst imparts at `dist` from its centre, falling
 *  off linearly to 0 at the edge. */
export function windBurstKnockback(dist: number): number {
  if (dist >= BREEZE.BURST_RADIUS) return 0;
  return BREEZE.KNOCKBACK * (1 - dist / BREEZE.BURST_RADIUS);
}

/** Radius (blocks) of a wind-charge burst. */
export function windBurstRadius(): number {
  return BREEZE.BURST_RADIUS;
}

/** Blocks a wind charge toggles when its burst reaches them (MC's wind-activatable
 *  set: the same things an arrow/redstone pulse can flip). */
const WIND_ACTIVATABLE = new Set([
  'lever', 'stone_button', 'oak_button', 'oak_door', 'oak_trapdoor', 'oak_fence_gate', 'bell',
]);
export function windChargeActivates(block: string): boolean {
  return WIND_ACTIVATABLE.has(block);
}

/** A breeze fires a wind charge on this cadence. */
export function breezeFireInterval(): number {
  return BREEZE.FIRE_INTERVAL;
}

/** Whether a breeze whose fire cooldown is `cd` may fire this tick. */
export function breezeReadyToFire(cd: number): boolean {
  return cd <= 0;
}

/** Direct-hit damage of a wind charge. */
export function windChargeDamage(): number {
  return BREEZE.DAMAGE;
}

/** Upward impulse a player gets from throwing a wind charge at their feet. */
export function windSelfLaunchImpulse(): number {
  return BREEZE.SELF_LAUNCH;
}
